import type { NTasksList } from '@app/pages/TasksList/types/TasksList.types';

export const getMassActionMenuItem = ({
  key,
  label,
  onClick,
  disabled,
  dataTestId = '',
}: NTasksList.GetMenuItemProps) => {
  return {
    key,
    label: <div data-testid={dataTestId}>{label}</div>,
    onClick,
    disabled,
  };
};
